import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Product", href: "/#features" },
  { label: "Meeting Notes", href: "/meeting-notes" },
  { label: "Apple Notes", href: "/apple-notes-companion" },
  { label: "Live Demo", href: "/demo" },
  { label: "Free Tools", href: "/tools" },
  { label: "Pricing", href: "/pricing" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  // The site-wide CTA used to open a sample *meeting*, which put meeting
  // capture in front of every blog post and tool page. The measured demand is
  // elsewhere: meeting queries drew 2,099 impressions and 1 click, four users
  // have ever transcribed, and the paywall people actually reach is
  // handwriting-to-text. A populated canvas still avoids the blank-page open
  // that made the sample worth having, without leading on the wrong job.
  const signupHref =
    "https://app.omnicanvasnotes.com?mode=try&template=brainstorm-web" +
    "&utm_source=marketing&utm_medium=nav" +
    `&utm_campaign=${encodeURIComponent(location.pathname)}`;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-slate-100">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2.5">
          <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">O</span>
          </div>
          <span className="font-bold text-lg tracking-tight">OmniCanvas</span>
        </a>

        <div className="hidden lg:flex items-center gap-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://app.omnicanvasnotes.com?mode=login"
            className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
          >
            Log In
          </a>
          <a
            href={signupHref}
            className="bg-indigo-600 text-white text-sm font-semibold px-5 py-2 rounded-full hover:bg-indigo-700 transition-colors"
          >
            Try the sample
          </a>
        </div>

        <button
          className="p-2 text-slate-600 lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-100 bg-white px-6 pb-4 lg:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="block py-3 text-sm font-medium text-slate-600"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://app.omnicanvasnotes.com?mode=login"
            className="block py-3 text-sm font-medium text-slate-600"
            onClick={() => setOpen(false)}
          >
            Log In
          </a>
          <a
            href={signupHref}
            className="mt-2 block text-center bg-indigo-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full"
            onClick={() => setOpen(false)}
          >
            Try the sample
          </a>
        </div>
      )}
    </nav>
  );
}
